import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import SEO from "../../components/SEO";

export default function TechnicalService() {
  const { mode, brand } = useBrand();
  const [page, setPage] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const slug = mode === "brand" ? brand.slug : "_all";
    api.get(`/pages/technical_service/${slug}`).then((r) => setPage(r.data));
  }, [mode, brand]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post(`/submissions`, {
        type: "technical_service",
        ...form,
        brand_slug: mode === "brand" ? brand.slug : null,
      });
      toast.success("Talebiniz alındı. En kısa sürede dönüş yapacağız.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fade-in-up" data-testid="tech-service-page">
      <SEO title="Teknik Servis" />
      <div className="border-b border-white/10 py-16 bg-gradient-to-b from-[#0A0A0A] to-[#050505]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Servis</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">Teknik Servis</h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div>
          <div className="text-sm text-zinc-300 leading-relaxed whitespace-pre-wrap">
            {page?.content ||
              "Tüm distribüte ettiğimiz ürünler için yetkili teknik servis hizmeti veriyoruz. Aşağıdaki formu doldurarak servis talebinde bulunabilirsiniz."}
          </div>
        </div>

        <form onSubmit={submit} className="border border-white/10 bg-[#0A0A0A] p-6" data-testid="tech-service-form">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-6">Servis Talebi</div>

          <div className="space-y-4">
            <input
              required
              type="text"
              placeholder="Adınız Soyadınız"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full bg-[#141414] border border-white/10 px-4 py-2.5 text-sm focus:outline-none focus:border-white/30"
              data-testid="tech-form-name"
            />
            <input
              required
              type="email"
              placeholder="E-posta"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-[#141414] border border-white/10 px-4 py-2.5 text-sm focus:outline-none focus:border-white/30"
              data-testid="tech-form-email"
            />
            <input
              type="text"
              placeholder="Telefon"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              className="w-full bg-[#141414] border border-white/10 px-4 py-2.5 text-sm focus:outline-none focus:border-white/30"
              data-testid="tech-form-phone"
            />
            <textarea
              required
              placeholder="Mesajınız / arızanın tanımı"
              rows={6}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              className="w-full bg-[#141414] border border-white/10 px-4 py-2.5 text-sm focus:outline-none focus:border-white/30"
              data-testid="tech-form-message"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="brand-btn mt-6 w-full py-3 text-sm uppercase tracking-[0.2em] disabled:opacity-50"
            data-testid="tech-form-submit"
          >
            {submitting ? "Gönderiliyor..." : "Talep Gönder"}
          </button>
        </form>
      </div>
    </div>
  );
}
